module.exports = __webpack_public_path__ + "static/media/pointBadgeLevel3Locked.64eab0d2.png";